var map = {
	"./game-all-1.png": 3976,
	"./game-all-10.png": 7786,
	"./game-all-11.png": 5539,
	"./game-all-12.png": 8680,
	"./game-all-13.png": 8897,
	"./game-all-14.png": 5806,
	"./game-all-15.png": 8295,
	"./game-all-16.png": 5644,
	"./game-all-17.png": 1557,
	"./game-all-18.png": 706,
	"./game-all-19.png": 5531,
	"./game-all-2.png": 5955,
	"./game-all-20.png": 1275,
	"./game-all-21.png": 146,
	"./game-all-22.png": 9881,
	"./game-all-23.png": 3632,
	"./game-all-24.png": 5855,
	"./game-all-25.png": 6838,
	"./game-all-26.png": 8045,
	"./game-all-27.png": 1364,
	"./game-all-28.png": 6659,
	"./game-all-29.png": 1450,
	"./game-all-3.png": 6122,
	"./game-all-30.png": 7024,
	"./game-all-31.png": 1225,
	"./game-all-32.png": 3042,
	"./game-all-33.png": 4587,
	"./game-all-34.png": 9780,
	"./game-all-35.png": 3021,
	"./game-all-36.png": 1254,
	"./game-all-37.png": 5055,
	"./game-all-38.png": 1640,
	"./game-all-39.png": 2414,
	"./game-all-4.png": 8181,
	"./game-all-40.png": 6881,
	"./game-all-5.png": 6556,
	"./game-all-6.png": 3591,
	"./game-all-7.png": 7806,
	"./game-all-8.png": 3561,
	"./game-all-9.png": 9360
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1984;